/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CurriculumOptionType {
    Qualification = 'qualification',
    HighSchoolFieldOfStudy = 'high_school_field_of_study',
    HighSchoolDegreeMarkBasis = 'high_school_degree_mark_basis',
    UniversityFieldOfStudy = 'university_field_of_study',
    UniversityDegreeMarkBasis = 'university_degree_mark_basis'
};

